import { FC, useEffect, useState } from 'react';
import ModalDialog from '../../../../shared/components/modal/ModalDialog';
import { ModalButtonLine } from '../../../../shared/components/modal/ModalButtonLine';
import { LocalContentRadioButtonGroup } from './LocalContentRadioButtonGroup';
import { Button, ButtonSize, ButtonTheme } from '../../../../shared/common/Button';
import { SpocState } from '../../../../store/authentication/state';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

export type SpocsType = Pick<SpocState, 'id' | 'name'>;

interface Props {
    spocs: SpocsType[];
    show: boolean;
    onSetLive: (spoc: string) => void;
    onAbort: () => void;
}

const StModalTitle = styled.h2`
    margin-bottom: 30px;
`;
export const SetLiveInCollectionPopup: FC<Props> = props => {
    const { t } = useTranslation();
    const [selectedSpoc, setSelectedSpoc] = useState<string | null>(null);

    const spocs = props.spocs.map(s => {
        let name = s.name;
        if (props.spocs.length > 1) {
            if (s.id.indexOf('PARTNER') >= 0) {
                name = t('yourLocalContent.yourTitles.sharedCollectionWithName', { name: name });
            } else {
                name = t('yourLocalContent.yourTitles.individualCollectionWithName', { name: name });
            }
        }
        return {
            key: s.id,
            value: name
        };
    });

    useEffect(() => {
        if (!selectedSpoc && props.show) {
            if (spocs && spocs.length === 1) {
                const selectedSpoc = props.spocs[0].id;
                setSelectedSpoc(selectedSpoc);
            } else {
                setSelectedSpoc(null);
            }
        }
    }, [props.show, props.spocs, selectedSpoc, spocs]);

    function onSetLive() {
        if (selectedSpoc) {
            props.onSetLive(selectedSpoc);
        }
    }

    function onRadioChanged(key) {
        setSelectedSpoc(key);
    }

    function handleOnAbort() {
        props.onAbort();
        setSelectedSpoc(null);
    }

    return (
        <ModalDialog
            show={props.show}
            title="&nbsp;"
            titleClassName="display-none"
            onCloseButtonClick={handleOnAbort}
            wrapClassName="lc-settings-popup"
            preventClosingAction={true}
        >
            <span>{t('yourLocalContent.yourTitles.step2')}</span>
            <StModalTitle>{t('yourLocalContent.yourTitles.setLiveInCollection')}</StModalTitle>
            <LocalContentRadioButtonGroup
                selectedOption={selectedSpoc}
                onRadioChanged={onRadioChanged}
                options={spocs}
            />

            <ModalButtonLine>
                <Button
                    size={ButtonSize.LARGE}
                    theme={ButtonTheme.NEUTRAL}
                    onClick={handleOnAbort}
                    text={t('cancel')}
                    className="bt2 width-90px"
                />

                <Button
                    size={ButtonSize.LARGE}
                    text={t('yourLocalContent.yourTitles.next')}
                    disabled={!selectedSpoc}
                    onClick={onSetLive}
                    className="bt2 width-90px"
                    data-testid="next-button"
                />
            </ModalButtonLine>
        </ModalDialog>
    );
};
